export default "__VITE_ASSET__e73b74d8__"